import { Divider, Grid } from "@mui/material";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import CatchmentHeader from "./CatchmentHeader";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";
import { styled } from "@mui/material/styles";

// Components
import ContentSection from "../../ContentSection";
import MxCatchmentForm from "./CatchmentForm";

// Hooks

// Types & Constants
import { IMxCatchment, IMxCatchmentFileHandler } from "./model/catchment.interface";

/**
 * Componente principal para gestión de etapas y documentación de proyectos
 * Permite configurar etapas del proyecto con sus unidades y fechas de entrega
 */
export const MxCatchment = ({
  color = "blue",
  title = "Detalles del proyecto",
  tooltip = "Indique el número de unidades del proyecto en cada etapa, según el master plan, no las unidades captadas"
}: IMxCatchment) => {
  const { showNotification } = useShowValidationInfo();
  const {
    validationDocuments: { master_plan }
  } = useFormValidationsDocumentsMsgSlice();

  const handleOnClickOnExternalIndicators: IMxCatchmentFileHandler["onClickOnExternalIndicators"] =
    (file, ctx, itemCtx) => {
      showNotification(itemCtx.msg, itemCtx.status);
    };

  return (
    <ContentSection
      color={color}
      title={title}
      tooltip={tooltip}
      defaultExpanded={true}
    >
      <Grid item xs={12}>
        <CatchmentHeader />
      </Grid>
      <StyledContent container item xs={12} mt={2}>
        <Grid item xs="auto" flex={1} flexGrow={0}>
          <MxCatchmentForm />
        </Grid>
        <Grid
          container
          item
          xs="auto"
          maxHeight={260}
          sx={{ display: { xs: "none", lg: "flex" }, margin: "3rem auto" }}
        >
          <Divider orientation="vertical" />
        </Grid>
        <Grid item xs sx={{ margin: "4rem auto" }}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.file_master_plan}
            maxSize={3}
            minSize={0}
            label="Imagen del master plan"
            disabled={master_plan?.disabled}
            typeKey={CValidationDocumentKeys.MasterPlan}
          />
        </Grid>
      </StyledContent>
    </ContentSection>
  );
};

export default MxCatchment;

const StyledContent = styled(Grid)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 5px minmax(200px, 300px)",
  gap: theme.spacing(2),

  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "1fr",
    gap: theme.spacing(3),
    "& .MuiDivider-vertical": {
      display: "none"
    }
  },

  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(2)
  },

  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(1.5)
  }
}));
